import React from 'react';
import { cn } from '@/lib/utils';

interface ActionToolbarProps {
    startContent?: React.ReactNode;
    endContent?: React.ReactNode;
    className?: string;
}

export const ActionToolbar: React.FC<ActionToolbarProps> = ({
    startContent,
    endContent,
    className,
}) => {
    return (
        <div className={cn("flex flex-wrap items-center justify-between gap-4 mb-6 bg-transparent", className)}>
            <div className="flex flex-wrap items-center gap-2">
                {startContent}
            </div>
            <div className="flex flex-wrap items-center gap-2">
                {endContent}
            </div>
        </div>
    );
};
